import { CollapseTransition } from 'vue2-transitions'
import messages from './MenuAdmin.json'

export default {
  name: 'MenuAdmin',

  i18n: messages,

  components: {
    CollapseTransition,
  },

  data() {
    return {
      isClosed: true,
    }
  },

  methods: {
    /**
     * gére l'affichage/masquage du bandeau de gauche
     */
    toggleMenu() {
      this.isClosed = !this.isClosed
    },

    /**
     * récupération des données
     */
    isAdmin() {
      return this.$store.getters.user.admin
    },
  },
}
